import { Badge, HStack, Switch, Tooltip, VStack } from '@elkaso-app/web-design';
import React from 'react';

export interface VerificationCellProps {
  id: number;
  isVerified: boolean;
  onToggle: (id: number, isVerified: boolean) => void;
  isLoading: boolean;
}

export const VerificationCell: React.FC<VerificationCellProps> = ({ id, isVerified, onToggle, isLoading }) => (
  <div style={{ height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px 0' }}>
    <VStack align='center' spacing={1}>
      <Tooltip label={isVerified ? 'Click to mark as Unverified' : 'Click to mark as Verified'}>
        <HStack spacing={2}>
          <Switch
            isChecked={isVerified}
            onChange={(e) => onToggle(id, e.target.checked)}
            colorScheme='green'
            isDisabled={isLoading}
            size='sm'
          />
          <Badge colorScheme={isVerified ? 'green' : 'red'} variant='subtle' size='sm'>
            {isVerified ? 'Verified' : 'Unverified'}
          </Badge>
        </HStack>
      </Tooltip>
    </VStack>
  </div>
);
